<header
  class="flex justify-between items-center bg-white dark:bg-gray-900 px-3 lg:px-6 border-gray-200 dark:border-gray-800 border-b h-16 transition-colors duration-200">

  <!-- ========================================================================= -->
  <!-- Left: Sidebar Toggle & Breadcrumb Navigation                              -->
  <!-- ========================================================================= -->
  <div class="flex items-center gap-2">
    <!-- Sidebar Toggle Button -->
    <p-button (onClick)="toggleSidebar.emit()"
      [icon]="isSidebarOpen ? 'ti ti-layout-sidebar-right text-2xl' : 'ti ti-layout-sidebar text-2xl'" [text]="true"
      [rounded]="true" severity="secondary" styleClass="w-10 h-10 text-gray-500 hover:text-gray-700 hover:bg-gray-100"
      ariaLabel="Toggle sidebar" />

    <!-- Breadcrumbs -->
    @if (!editorState.isEditorOpen()) {
    <div class="ml-4 text-gray-800">
      <p-breadcrumb [model]="menuItems()" class="text-sm" />
    </div>
    }
  </div>

  <!-- ========================================================================= -->
  <!-- Right: Theme Toggle, Quick Actions & User Profile                         -->
  <!-- ========================================================================= -->
  <div class="flex items-center gap-6">
    <!-- Theme Toggle Button -->
    <p-button [text]="true" [rounded]="true" severity="secondary" styleClass="w-10 h-10 dark:text-zinc-400"
      (onClick)="popoverClick($event)" aria-label="Theme selector" pTooltip="Change theme" tooltipPosition="bottom">
      <ng-template pTemplate="content">
        <i [class]="currentThemeIcon + ' text-2xl'"></i>
      </ng-template>
    </p-button>

    <!-- Notification Button (Disabled) -->
    <p-button [text]="true" [rounded]="true" severity="contrast" styleClass="relative w-10 h-10" [disabled]="true"
      aria-label="Notifications">
      <ng-template pTemplate="content">
        <i class="ti ti-bell text-2xl"></i>
      </ng-template>
    </p-button>

    <!-- App Grid Button (Disabled) -->
    <p-button [text]="true" [rounded]="true" icon="ti ti-layout-grid text-2xl!" severity="contrast"
      styleClass="w-10 h-10" [disabled]="true" aria-label="Applications" />

    <!-- User Profile Avatar Button -->
    <p-avatar pTooltip="{{ firstName + ' ' + lastName }}" tooltipPosition="right" (click)="menu.toggle($event)"
      [image]="hasImage ? profileImage : undefined" [label]="!hasImage ? initials : undefined" shape="circle"
      class="cursor-pointer w-10! h-10!" size="normal" />
  </div>
</header>

<!-- =========================================================================== -->
<!-- Overlays & Popovers                                                         -->
<!-- =========================================================================== -->

<!-- Theme Selector Popover -->
<p-popover #themePopover>
  <div class="flex flex-col w-44 py-1">
    <p class="text-xs font-semibold text-zinc-500 dark:text-zinc-400 uppercase tracking-wider px-3 py-2">
      Appearance
    </p>
    @for (option of themeOptions; track option.value) {
    <p-button severity="secondary" (onClick)="setTheme(option.value, themePopover)" class="w-full" [styleClass]="
          'w-full mt-2 flex items-center gap-3 justify-start ' +
          (themeService.mode() === option.value
            ? 'bg-brand-50! text-brand-600! dark:text-white! dark:bg-zinc-800! dark:border-zinc-800!'
            : 'dark:text-zinc-400! bg-white! dark:bg-zinc-900! border-white! dark:border-zinc-900! hover:bg-zinc-100! dark:hover:bg-zinc-800!')
        ">
      <i [class]="option.icon + ' text-lg'"></i>
      <span class="flex-1 text-left">{{ option.label }}</span>
      @if (themeService.mode() === option.value) {
      <i class="ti ti-check text-green-500 ml-auto"></i>
      }
    </p-button>
    }
  </div>
</p-popover>

<!-- User Profile Menu -->
<p-menu #menu [popup]="true" [model]="items">
  <ng-template #start>
    <div class="flex items-center gap-2 p-3 border-b border-gray-200">
      <p-avatar [image]="hasImage ? profileImage : undefined" [label]="!hasImage ? initials : undefined" shape="circle"
        class="cursor-pointer w-10! h-10!" size="normal" />
      <div>
        <p class="text-sm font-semibold">{{ firstName }} {{ lastName }}</p>
        <p class="text-xs text-gray-500">{{ lastName }}</p>
      </div>
    </div>
  </ng-template>

  <ng-template #submenuheader let-item>
    <span class="text-primary font-bold text-sm">{{ item.label }}</span>
  </ng-template>

  <ng-template #item let-item>
    <a pRipple tabindex="-1" class="p-menu-item-link flex items-center px-2.5 py-1.5 cursor-pointer"
      [class]="item.linkClass" [ngClass]="{ 'text-red-500!': item.label === 'Logout' }">
      <span [class]="item.icon"></span>
      <span class="ms-2 text-sm">{{ item.label }}</span>

      @if (item.shortcut) {
      <span class="ms-auto border border-surface rounded-sm bg-emphasis text-muted-color text-xs px-1 py-0.5">
        {{ item.shortcut }}
      </span>
      }
    </a>
  </ng-template>
</p-menu>